import { useContext, useEffect } from "react";
import { MaterialContext } from "../context/MaterialContext";
import Swatch from "../components/Swatch";
import LoadingDots from "../components/LoadingDots";
import LibraryResultBanner from "../components/LibraryResultBanner";

function Library() {
  const {
    materials,
    materialsLoaded,
    search,
    changeSearch,
    status,
    orderBy,
    isFilter,
    changeIsFilter,
  } = useContext(MaterialContext);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [search, status, orderBy]);

  const handleClearFilterSearch = () => {
    changeIsFilter(false);
    changeSearch("");
  };

  return (
    <div className="content">
      {!materialsLoaded ? (
        <LoadingDots
          label="Loading Material Swatches..."
          containerClassName="libraryLoadingState"
          labelClassName="libraryLoadingText"
          dotsClassName="libraryLoadingDots"
        />
      ) : null}
      <div className="swatch-view library-swatch-view">
        {materialsLoaded &&
          materials?.map((material) => (
            <Swatch key={material.id} id={material.id} />
          ))}
        {search && !isFilter && (
          <LibraryResultBanner
            count={materials.length}
            queryLabel={`"${search}"`}
            actionLabel="Clear Search"
            onAction={handleClearFilterSearch}
          />
        )}
        {isFilter && !search && (
          <LibraryResultBanner
            count={materials.length}
            queryLabel="Filter"
            actionLabel="Clear Filter"
            onAction={handleClearFilterSearch}
          />
        )}
        {isFilter && search && (
          <LibraryResultBanner
            count={materials.length}
            queryLabel="Filter & Search"
            actionLabel="Clear All"
            onAction={handleClearFilterSearch}
          />
        )}
      </div>
    </div>
  );
}

export default Library;
